// Emails allowed to see the Admin screen. Must match the SQL admin policies.
export const ADMIN_EMAILS = ['tony@tidytradie.com.au'];

export function isAdmin(email: string | undefined | null): boolean {
  return !!email && ADMIN_EMAILS.includes(email.toLowerCase());
}
